import React, { useContext, useState, useEffect } from 'react';
import AddOwnershipData from 'src/models/tract_detail/add_ownership_revised/AddOwnership';
import AddWIOwnershipData from 'src/models/tract_detail/add_ownership_revised/AddWIOwnership';
import AddOwner from 'src/models/tract_detail/add_ownership_revised/AddOwner';
import Dialog from 'src/components/common/Dialog.redesign';
import NewOwnerForm from '../../TractComponents/NewOwnershipForm';
import AddOwnershipPages from '../../TractComponents/AddOwnershipPages';
import { AnyObject } from 'react-final-form';
import DialogList from 'src/dialogs';
import OwnerType from '../../TractComponents/OwnerType';
import * as _ from 'lodash';
import { FormErrors } from 'src/util/FormErrors';
import ExistingOwnerForm from '../../TractComponents/ExistingOwnerForm';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'src/actions';
import { IAppContextState } from 'src/reducers/AppContext';
import { AppContext } from 'src/providers/AppContextProvider';
import { IRootState } from 'src/reducers';
import { ODataFilter, ODataOptions, ODataFilterOperators } from 'src/util/ODataBuilder';
import LeaseGenerationTractDetail from 'src/models/leasing/LeaseGenerationTractDetail';
import useFetch from 'use-http';

interface IAddContractOwnershipDialogProps {
    dialogName: string;
    title: string;
    horizon?: number;
    parentOwnershipId?: number;
    clientNumber: number;
    projectNumber: number;
    pageNumber: number;

    navigate: (path: string) => void;
    saveAddTractOwnership?: (values: AddOwnershipData) => void;
    saveAddContractOwnership?: (values: AddWIOwnershipData) => void;
    onCloseDialog?: () => void;
}

const AddContractOwnershipDialog = (props: IAddContractOwnershipDialogProps) => {
    const [page, setPage] = useState<AddOwnershipPages>(AddOwnershipPages.AddOwnershipLandingPage);
    const [ownerTracts, setOwnerTracts] = useState<Array<LeaseGenerationTractDetail>>([]);

    const { tract } = useSelector((state: IRootState) => state);
    const { state: selectState } = useSelector((state: IRootState) => state);
    const { owner: selectOwner } = useSelector((state: IRootState) => state);
    const { phoneNumberType: selectPhoneNumberTypes } = useSelector((state: IRootState) => state);
    const { get, response } = useFetch();

    useEffect(() => {
        dispatch(actions.state.getStates(new ODataOptions().addPaging(1, 100)));
        dispatch(actions.phoneNumberType.getPhoneNumberTypes());
        setPage(props.pageNumber);
    }, []);

    const appContext = useContext<IAppContextState>(AppContext);
    const dispatch = useDispatch();

    const ownershipType = ['FEE', '0', '1'];

    // add owner types
    const ownerTypes = [
        { id: OwnerType.Individual, name: 'Individual' },
        { id: OwnerType.Trust, name: 'Trust' },
        { id: OwnerType.Business, name: 'Business' },
        { id: OwnerType.GovBLM, name: 'Gov-BLM' },
        { id: OwnerType.GovRAL, name: 'Gov-RAL' },
        { id: OwnerType.GovSTATE, name: 'Gov-STATE' },
        { id: OwnerType.JointTenant, name: 'Joint Tenant' },
    ];

    const searchOwners = (searchText: string, ownerType: string) => {
        let searchOptions = new ODataOptions().addPaging(1, 100);
        searchOptions.addFilter(new ODataFilter('omni', ODataFilterOperators.Contains, searchText));
        searchOptions.addFilter(new ODataFilter('type', ODataFilterOperators.Equals, ownerType));
        dispatch(actions.tract.getSearchPagedOwners(appContext.clientNumber, appContext.projectNumber, searchOptions));
    };

    const onGetTractsByOwnerId = async (id: number) => {
        const result = await get(
            `v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/leasegeneration/owner/${id}`
        );

        if (response.ok) {
            setOwnerTracts(result.tracts);
        }
    };

    const addDeviation = (values: AddOwner, containerOwnerId: number, ownerType: string) => {
        dispatch(actions.owner.addDeviation(appContext.clientNumber, appContext.projectNumber, values, containerOwnerId, ownerType));
    };

    const onGetOwnerDetail = (ownerId: number, containerId: number, type: string) => {
        dispatch(actions.owner.getOwnerDetails(appContext.clientNumber, appContext.projectNumber, ownerId, containerId, type));
    };

    const validate = (values: AnyObject) => {
        values.ownerType = parseInt(values.ownerType, 10);
        const errors: AnyObject = {};
        if (page === AddOwnershipPages.NewOwnerDecimalInterest || page === AddOwnershipPages.DeviationDecimalInterest) {
            if (!_.get(values, 'contractOwnership.decimalInterest')) {
                _.set(errors, 'contractOwnership.decimalInterest', 'Required');
            }
            if (
                props.dialogName === DialogList.ADD_ADDITIONAL_OWNERSHIP &&
                props.parentOwnershipId > 0 &&
                !_.get(values, 'contractOwnership.additionalOwnershipTypeId')
            ) {
                _.set(errors, 'contractOwnership.additionalOwnershipTypeId', 'Required');
            }
        }
        if (page === AddOwnershipPages.NewOwnerInfoForm || page === AddOwnershipPages.NewDeviationInfoForm) {
            if (values.ownerType === OwnerType.Individual) {
                if (!_.get(values, 'individualOwner.firstName')) {
                    _.set(errors, 'individualOwner.firstName', 'Required');
                }
                if (!_.get(values, 'individualOwner.lastName')) {
                    _.set(errors, 'individualOwner.lastName', 'Required');
                }
            } else if (values.ownerType === OwnerType.Trust) {
                if (!_.get(values, 'ownerTrust.trustName')) {
                    _.set(errors, 'ownerTrust.trustName', 'Required');
                }
                if (!_.get(values, 'ownerTrust.contactPersonFirstName')) {
                    _.set(errors, 'ownerTrust.contactPersonFirstName', 'Required');
                }
                if (!_.get(values, 'ownerTrust.contactPersonLastName')) {
                    _.set(errors, 'ownerTrust.contactPersonLastName', 'Required');
                }
                if (!_.get(values, 'ownerTrust.trustees')) {
                    _.set(errors, 'ownerTrust.trustees', 'Required');
                }
            } else if (values.ownerType === OwnerType.Business) {
                if (!_.get(values, 'businessOwner.name')) {
                    _.set(errors, 'businessOwner.name', 'Required');
                }
                if (!_.get(values, 'businessOwner.contactPersonFirstName')) {
                    _.set(errors, 'businessOwner.contactPersonFirstName', 'Required');
                }
                if (!_.get(values, 'businessOwner.contactPersonLastName')) {
                    _.set(errors, 'businessOwner.contactPersonLastName', 'Required');
                }
            } else if (values.ownerType === OwnerType.GovBLM) {
                if (!_.get(values, 'bolmOwner.regionalOffice')) {
                    _.set(errors, 'bolmOwner.regionalOffice', 'Required');
                }
                if (!_.get(values, 'bolmOwner.contactPersonFirstName')) {
                    _.set(errors, 'bolmOwner.contactPersonFirstName', 'Required');
                }
                if (!_.get(values, 'bolmOwner.contactPersonLastName')) {
                    _.set(errors, 'bolmOwner.contactPersonLastName', 'Required');
                }
            } else if (values.ownerType === OwnerType.GovRAL) {
                if (!_.get(values, 'ralOwner.stateId')) {
                    _.set(errors, 'ralOwner.stateId', 'Required');
                }
                if (!_.get(values, 'ralOwner.surfaceOwnerAgentFirstName')) {
                    _.set(errors, 'ralOwner.surfaceOwnerAgentFirstName', 'Required');
                }
                if (!_.get(values, 'ralOwner.surfaceOwnerAgentLastName')) {
                    _.set(errors, 'ralOwner.surfaceOwnerAgentLastName', 'Required');
                }
            } else if (values.ownerType === OwnerType.GovSTATE) {
                if (!_.get(values, 'stateLandOwner.agencyName')) {
                    _.set(errors, 'stateLandOwner.agencyName', 'Required');
                }
                if (!_.get(values, 'stateLandOwner.contactPersonFirstName')) {
                    _.set(errors, 'stateLandOwner.contactPersonFirstName', 'Required');
                }
                if (!_.get(values, 'stateLandOwner.contactPersonLastName')) {
                    _.set(errors, 'stateLandOwner.contactPersonLastName', 'Required');
                }
            } else if (values.ownerType === OwnerType.JointTenant) {
                // ownerJointTenant.name
                if (!_.get(values, 'ownerJointTenant.name')) {
                    _.set(errors, 'ownerJointTenant.name ', 'Required');
                }
            }
        }
        // console.log(errors);
        return errors as FormErrors<AnyObject>;
    };

    const initializeFormAndState = () => {
        dispatch(actions.tract.clearSearchResults());
        dispatch(actions.tract.initializeOwnerTracts());
        setPage(props.pageNumber === 2 ? AddOwnershipPages.NewOwnerInfoForm : AddOwnershipPages.AddOwnershipLandingPage);
    };

    const cleanValues = (values: AnyObject) => {
        console.log('clean values', values);
        if (values.contractOwnership && values.contractOwnership.ownershipType) {
            values.contractOwnership.ownershipType = ownershipType.find((x, index) => index === parseInt(values.contractOwnership.ownershipType, 10));
        }
        if (values.ownerType) {
            values.ownerType = parseInt(values.ownerType + '', 10);
        }
        if (values.contractOwnership && values.contractOwnership.decimalInterest) {
            values.contractOwnership.decimalInterest = parseFloat(values.contractOwnership.decimalInterest + '');
        }
        values.contractOwnership.ownershipType = 'FEE';
        return values;
    };

    const submitOwnership = (formValues: AnyObject) => {
        if (props.dialogName === DialogList.ADD_OWNERSHIP || props.dialogName === DialogList.ADD_ADDITIONAL_OWNERSHIP) {
            const values = cleanValues(formValues) as AddOwnershipData;
            console.log('submitOwnership', values);
            props.saveAddTractOwnership(values);
        } else if (props.dialogName === DialogList.ADD_WI_OWNERSHIP || props.dialogName === DialogList.ADD_ORRI_OWNERSHIP) {
            const values = cleanValues(formValues) as AddWIOwnershipData;
            props.saveAddContractOwnership(values);
        }

        initializeFormAndState();
        props.onCloseDialog();
    };

    return (
        <Dialog title={props.title}>
            <div style={{ width: '100rem' }}>
                <NewOwnerForm
                    validate={validate}
                    submitOwnership={submitOwnership}
                    dialogType={props.dialogName}
                    getCityState={(zipCode: string) => dispatch(actions.tract.getCityState(zipCode))}
                    horizon={props.horizon}
                    ownerTypes={ownerTypes}
                    ownershipType={ownershipType}
                    page={page}
                    phoneNumberTypes={selectPhoneNumberTypes.phoneNumberTypes}
                    searchResults={tract.pagedSearchOwnersResults}
                    states={selectState.states}
                    tract={tract.tractDetail}
                    turnPage={(addOwnershipPage) => setPage(addOwnershipPage)}
                    parentOwnershipId={props.parentOwnershipId}
                    initializeFormAndState={initializeFormAndState}
                    isLeasehold={false}
                />
                <ExistingOwnerForm
                    clientNumber={props.clientNumber}
                    projectNumber={props.projectNumber}
                    getCityState={(zipCode: string) => dispatch(actions.tract.getCityState(zipCode))}
                    getTractsByOwnerId={onGetTractsByOwnerId}
                    horizon={props.horizon}
                    ownerDetails={selectOwner.ownerDetails}
                    ownerTracts={ownerTracts}
                    ownerTypes={ownerTypes}
                    page={page}
                    phoneNumberTypes={selectPhoneNumberTypes.phoneNumberTypes}
                    submitOwnership={submitOwnership}
                    validate={validate}
                    searchOwners={searchOwners}
                    searchResults={tract.pagedSearchOwnersResults}
                    states={selectState.states}
                    tract={tract.tractDetail}
                    turnPage={(addOwnershipPage) => setPage(addOwnershipPage)}
                    addDeviation={addDeviation}
                    getOwnerDetail={onGetOwnerDetail}
                    parentOwnershipId={props.parentOwnershipId}
                    dialogType={props.dialogName}
                    isLeasehold={false}
                />
            </div>
        </Dialog>
    );
};

export default AddContractOwnershipDialog;



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/redesign/AddContractOwnershipDialog.tsx